<template>
  <div class="paper-choice-set">
    <PaperWrap>
      <template #default="{paperBatchId}">
        <div class="cont-wrap">
          <el-tabs v-model="activeTab">
            <template v-if="paperBatchId">
              <el-tab-pane v-for="tab in tabs"
                          :key="tab.value"
                          :name="tab.value"
                          :label="tab.label"
                          lazy>
                <component :is="tab.component"
                          :paper-batch-id="paperBatchId"
                          :active-tab="activeTab === tab.value"></component>
              </el-tab-pane>
            </template>
            <Hint v-else>请先选择论文批次</Hint>
          </el-tabs>
        </div>
      </template>
    </PaperWrap>
  </div>
</template>

<script>
import PaperChoiceSetTime from './time'
import PaperChoiceSetTeacher from './teacher'
import PaperChoiceSetStuClass from './stuClass'
import PaperChoiceSetStudent from './student'
import Hint from '../../../../../../elements/Hint.vue'
import PaperWrap from '../../wrap'
export default {
  name: 'PaperChoiceSet',
  components: {
    Hint,
    PaperWrap
  },
  data () {
    return {
      activeTab: 'time',
      tabs: [{
        label: '时间设置',
        value: 'time',
        component: PaperChoiceSetTime
      }, {
        label: '指导老师管理',
        value: 'teacher',
        component: PaperChoiceSetTeacher
      }, {
        label: '按班级分配',
        value: 'classes',
        component: PaperChoiceSetStuClass
      }, {
        label: '按学生分配',
        value: 'student',
        component: PaperChoiceSetStudent
      }]
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-set{
  height: 100%;
  .cont-wrap{
    height: 100%;
    ::v-deep  .el-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      &.el-tabs--top {
        position: relative;
        height: 100%;
        & > .el-tabs__header {
          margin-bottom: 0;
          padding: 0 15px;
          box-sizing: border-box;
          background-color: #fff;
          & > .el-tabs__nav-wrap {
            & > .el-tabs__nav-scroll {
              & > .el-tabs__nav {
                & > .el-tabs__item {
                  min-width: 92px;
                  height: 36px;
                  font-size: 12px;
                  text-align: center;
                  line-height: 36px;
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          flex: 1;
          height: 0;
          & > .el-tab-pane {
            height: 100%;
            padding: 10px 20px;
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
